import service from '../utils/request'
import router from '../router/index'
import store from "../store";
// 登录
export const requestLogin = params => {
    return service.get(`/api/auth/login`, { params: params });
};
//刷新token
export const refreshToken = params => {
    return service.get(`/api/auth/RefreshToken`, { params: params })
};
//根据token获取用户信息
export const getUserByToken = params => {
    return service.get(`/api/auth/getInfoByToken`, { params: params })
};
//获取路由信息
export const getNavigationBar = params => {
    return service.get(`/api/auth/GetNavigationBar`, { params: params })
};
// 获取系统时间
export const getsystemtime = params => {return service.get(`/api/auth/getsystemtime`, { params: params })};
export const saveRefreshtime = params => {
    let nowtime = new Date();
    let lastRefreshtime = window.localStorage.refreshtime ? new Date(window.localStorage.refreshtime) : new Date(-1);
    let expiretime = new Date(Date.parse(window.localStorage.TokenExpire))
    let refreshCount = 60; //滑动系数
    if (lastRefreshtime >= nowtime) {
        lastRefreshtime = nowtime > expiretime ? nowtime : expiretime;
        lastRefreshtime.setMinutes(lastRefreshtime.getMinutes() + refreshCount);
        window.localStorage.refreshtime = lastRefreshtime;
    } else {
        window.localStorage.refreshtime = new Date(-1);
    }
};
export const ToLogin = params => {
    store.commit("saveToken", "");
    store.commit("saveTokenExpire", "");
    store.commit("saveTagsData", "");
    window.localStorage.removeItem('user');
    window.localStorage.removeItem('NavigationBar');
    router.replace({
        path: "/login",
        query: { redirect: router.currentRoute.fullPath }
    });
    window.location.reload()
};